import React from 'react'
import { Box, Button } from '@mui/material'
import { useRouter } from 'next/router'
import { useLocale } from 'src/locales/useLocale'
import { ConfirmDialog } from 'src/Components/Ui/ConfirmDialog'
import { useConfirm } from 'src/hooks/useConfirm'

type Props = {
  handleDialogOpen: () => void
}

export const SettingButtons: React.FC<Props> = ({ handleDialogOpen }) => {
  const router = useRouter()
  const { t } = useLocale()
  const { isConfirmOpen: isConfirmOpenToTop, handleConfirmOpen: handleConfirmOpenTotop, handleConfirmClose: handleConfirmCloseTotop } = useConfirm()
  const { isConfirmOpen: isConfirmOpenReset, handleConfirmOpen: handleConfirmOpenReset, handleConfirmClose: handleConfirmCloseReset } = useConfirm()

  const handleLinkToTop = () => {
    router.push('/')
    handleConfirmCloseTotop()
  }

  const handleReset = () => {
    router.reload()
    handleConfirmCloseReset()
  }
  return (
    <Box display="flex" justifyContent="space-around" my={2}>
      <ConfirmDialog
        key={t.CONFIRM_TO_TOP}
        isConfirmOpen={isConfirmOpenToTop}
        openButtonLabel={t.TO_TOP}
        dialogMessage={t.CONFIRM_TO_TOP}
        handleOkButton={handleConfirmOpenTotop}
        handleCancelButton={handleConfirmCloseTotop}
        handleExecuteButton={handleLinkToTop}
        color={'primary'}
      />
      <ConfirmDialog
        isConfirmOpen={isConfirmOpenReset}
        openButtonLabel={t.RESET}
        dialogMessage={t.CONFIRM_RESET}
        handleOkButton={handleConfirmOpenReset}
        handleCancelButton={handleConfirmCloseReset}
        handleExecuteButton={handleReset}
        color={'primary'}
      />
      <Button variant="contained" color="primary" onClick={handleDialogOpen}>
        {t.CONFIRM}
      </Button>
    </Box>
  )
}
